import React, { useEffect, useRef, useState } from "react"
import Switch from "react-switch"

import $ from "jquery"
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css"
// import "datatables.net-dt";
import "datatables.net-bs4"
import axios from "axios"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import {
  editVirtualUser,
  getAutoUserJoinData,
  setAutoUserJoinData,
} from "services/ApiService"
import { toast, ToastContainer } from "react-toastify"
import { Row, Col, Card, CardBody, CardTitle, Container } from "reactstrap"
import { set } from "lodash"
window.$ = window.jQuery = $

const EventDataTable = ({ apiURL, idName }) => {
  const tableRef = useRef(null)
  const token = localStorage.getItem("authorizedToken")
  const [tableData, setTableData] = useState([])
  const [isEventType, setIsEventType] = useState(0) // 0 for upcoming , 1 for in progress ,2 for completed
  const [currentNovData, setCurrentNovData] = useState({})
  const [nov, setNov] = useState(null)
  const [originalNov, setOriginalNov] = useState(null)
  const [show, setShow] = useState(false)
  const [switch1, setswitch1] = useState(true)
  const [saveLoader, setSaveLoader] = useState(false)

  const fetchData = (dataTablesData, callback) => {
    $("#customLoader").show()
    const reqObj = {
      ...dataTablesData,
      eventStatus: isEventType,
    }
    axios
      .post(apiURL, reqObj, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response => {
        const res = response.data
        console.log("res in events....", res.data)
        $("#customLoader").hide()
        callback({
          draw: dataTablesData.draw,
          recordsTotal: res.recordsTotal,
          recordsFiltered: res.recordsFiltered,
          data: res.data,
        })
        setTableData(res.data)
      })
      .catch(err => {
        if (err.response && err.response.status === 401) {
          localStorage.clear()
          window.location.reload()
        } else {
          console.error("Error fetching data:", err)
        }
      })
  }

  useEffect(() => {
    handleGetAutoUserJoin()
  }, [])

  useEffect(() => {
    if (tableRef.current) {
      const table = $(tableRef.current).DataTable({
        processing: true,
        serverSide: true,
        searching: false,
        ajax: fetchData,
        columns: [
          // { data: "id", title: "ID"  , orderable: false  },

          {
            data: "startTime",
            title: "Start Time",
            orderable: false,
            render: function (data) {
              if (!data) return ""
              const date = new Date(data)
              var gmtDate = ""
              const formattedDate =
                date.getUTCFullYear() +
                "-" +
                String(date.getUTCMonth() + 1).padStart(2, "0") +
                "-" +
                String(date.getUTCDate()).padStart(2, "0") +
                " " +
                String(date.getUTCHours()).padStart(2, "0") +
                ":" +
                String(date.getUTCMinutes()).padStart(2, "0") +
                ":" +
                String(date.getUTCSeconds()).padStart(2, "0")

              return formattedDate
            },
          },
          { data: "nop", title: "Participants", orderable: false },
          {
            data: "null",
            title: "Joined /Virtual Participants",
            orderable: false,
            render: function (data, type, row) {
              const nov = row.nov ?? 0
              const nojv = row.noOfJoinVirtualUser ?? 0

              // console.log("nov", nov)
              // console.log("nojv", nojv)
              return `${nojv} / ${nov}`
            },
          },
          // {
          //   data: "noOfJoinVirtualUser",
          //   title: "Joined V Participants",
          //   orderable: false,
          // },
          // { data: "createdAt", title: "Created At", orderable: false },
          // { data: "updatedAt", title: "Updated At", orderable: false },
          {
            data: "null",
            title: "Action",
            orderable: false,
            visible: isEventType === 0,
            render: function (data, type, row) {
              return `
               <button class="btn p-0 edit-btn"  data-id="${row.id}">
        <i class="bx bx-pencil fs-4"></i>
      </button>
            `
            },
          },
        ],
        destroy: true,
        createdRow: row => {
          // Apply inline style to center text in each cell
          $("td", row).css("text-align", "center")
        },
        headerCallback: thead => {
          // Apply inline style to center text and set background color in header cells
          $("th", thead).css({
            "text-align": "center",
            "background-color": "#f2f2f2", // Change this to your desired color
          })
        },
      })

      $(tableRef.current).on("click", ".edit-btn", function () {
        const data = table.row($(this).parents("tr")).data()
        editEvent(data)
      })
      // $(tableRef.current).on("click", ".edit-btn", function () {
      //   const data = table.row($(this).parents("tr")).data();
      //   editEvent(data);
      // });
    }
  }, [idName, isEventType])

  const editEvent = data => {
    setCurrentNovData(data)
    setNov(data.nov)
    setOriginalNov(data.nov)
    handleShow()
  }

  const handleSaveEditEvent = () => {
    setSaveLoader(true)
    const reqObj = {
      eventId: currentNovData.id,
      nov: nov,
    }
    // console.log("reqObj.. ", reqObj)
    let shownError = false
    editVirtualUser(reqObj)
      .then(res => {
        setSaveLoader(false)
        handleClose()
        toast.success(res.msg || "Virtual User Updated Successfully")
        const table = $(tableRef.current).DataTable()
        table.ajax.reload(null, false) // false to keep the current page
        // console.log("res ", res)
      })
      .catch(err => {
        setSaveLoader(false)
        console.log()
        if (err?.errors && Array.isArray(err.errors)) {
          err.errors.forEach(error => {
            if (error?.msg && !shownError) {
              toast.error(error.msg)
              shownError = true
            }
          })
        } else if (err?.response?.data?.msg && !shownError) {
          toast.error(err.response.data.msg)
          shownError = true
        } else {
          console.error("Unhandled error:", err)
        }
      })
  }
  const handleClose = () => {
    setShow(false)
  }
  const handleShow = () => setShow(true)

  // console.log("nov", nov)
  // console.log("currentEventData", currentNovData)
  const handleEventType = type => {
    setIsEventType(type)
  }
  const handleGetAutoUserJoin = () => {
    getAutoUserJoinData().then(res => {
      setswitch1(res.data)
      // console.log("getAutoUserJoinData", res.data)
    })
  }
  const handleSetAutoUserJoin = value => {
    const reqObj = {
      status: value,
    }
    setAutoUserJoinData(reqObj).then(res => {
      // console.log("setAutoUserJoinData", res.data)
    })
  }

  return (
    <div>
      <ToastContainer />
      {/* <h2>Event List</h2> */}
      <div>
        <div className="">
          <Row>
            <Col lg="10">
              <div className="flex space-x-2 my-3 ">
                <button
                  onClick={() => handleEventType(0)}
                  className={`px-4 py-2 rounded-lg transition-all duration-300 border border-blue-800 ${
                    isEventType === 0
                      ? "bg-blue-600 text-gray shadow-md"
                      : "bg-white text-muted hover:bg-blue-100"
                  }`}
                >
                  Upcoming Events
                </button>

                <button
                  onClick={() => {
                    handleEventType(1)
                  }}
                  className={`px-4 py-2 rounded-lg transition-all duration-300 border border-blue-600 ${
                    isEventType === 1
                      ? "bg-blue-600 text-gray shadow-md "
                      : "bg-white text-muted hover:bg-blue-100"
                  }`}
                >
                  In Progress Events
                </button>

                <button
                  onClick={() => handleEventType(2)}
                  className={`px-4 py-2 rounded-lg transition-all duration-300 border border-blue-600 ${
                    isEventType === 2
                      ? "bg-blue-600 text-gray shadow-md"
                      : "bg-white text-muted  hover:bg-blue-100"
                  }`}
                >
                  Completed Events
                </button>
              </div>
            </Col>
            <Col lg="2">
              <div className="d-flex flex-column align-items-center text-center">
                <h4 className="mb-1">Fictitious Users</h4>
                <Switch
                  uncheckedIcon={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        fontSize: 12,
                        color: "#fff",
                        paddingRight: 2,
                      }}
                    >
                      Off
                    </div>
                  }
                  checkedIcon={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        fontSize: 12,
                        color: "#fff",
                        paddingRight: 2,
                      }}
                    >
                      On
                    </div>
                  }
                  onColor="#626ed4"
                  onChange={checked => {
                    setswitch1(checked)
                    handleSetAutoUserJoin(checked) // ✅ Call API here, not inside the icon
                  }}
                  checked={switch1}
                />
              </div>
            </Col>
          </Row>
        </div>
        <div className="table-responsive">
          <table
            id={`dataTable${idName}`}
            ref={tableRef}
            className="table table-hover table-bordered text-center my-3"
            style={{ width: "100%", fontSize: 14, color: "#858D9D" }}
          ></table>
        </div>
      </div>
      {/* <table ref={tableRef} className="display" style={{ width: "100%" }}></table> */}

      <Modal isOpen={show} toggle={handleClose}>
        <ModalHeader toggle={handleClose}>Edit Event</ModalHeader>
        <ModalBody>
          <div className="">
            <form action="">
              <label htmlFor="nov">Virtual Participants</label>
              <input
                type="text"
                value={nov}
                className="form-control"
                id="nov"
                onChange={e => setNov(e.target.value)}
              />
            </form>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleClose}>
            Close
          </Button>
          {/* <Button color="primary" onClick={handleClose}>
            Save Changes
          </Button> */}
          <Button
            color="primary"
            onClick={handleSaveEditEvent}
            disabled={nov === originalNov}
            className=""
          >
            {saveLoader ? (
              <div
                className="spinner-border spinner-border-sm text-light mx-5"
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            ) : (
              " Save Changes"
            )}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  )
}

export default EventDataTable
